// extracted by mini-css-extract-plugin
export default {"shortBody":"Short_shortBody__DLsWC","shortTitle":"Short_shortTitle__dynZ9","shortSubtitle":"Short_shortSubtitle__-qXtc"};